// removed by extract-text-webpack-plugin
module.exports = {"email-input-answers":"EmailField__email-input-answers___M-1c1"};